import { NavBar } from "../component/NavBar.jsx"
import { SideBar } from "../component/SideBar.jsx"

export const CountyAnalyticsPage = ()=>{
    return (
        <div>
        <NavBar/>
        <SideBar selector="county-analytics"/>
        <div className="container">
            <h1>Analytics</h1>
            County analytics content </div>
        
        </div>
    )
};